import { createFileRoute, useNavigate, Link } from '@tanstack/react-router';
import { ExternalLink, ArrowLeft, ArrowUpRight } from '@/components/icons';
import { AppLayout } from '@/components/AppLayout';
import { TopBarBackIconButton } from '@/components/topbar/TopBarBackIconButton';
import { DesktopPage } from '@/components/desktop/DesktopPage';
import { DesktopPageHeader } from '@/components/desktop/DesktopPageHeader';
import { useIsDesktop } from '@/components/ui/use-mobile';

export const Route = createFileRoute('/_auth/operations/settings/privacy')({
  component: PrivacyPolicyRoute,
});

function PrivacyPolicyRoute() {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();

  const body = (
    <a
      href="https://www.pronteer.com/privacypolicy"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-3 w-full bg-surface-L0 border border-border-L2 rounded-2xl px-4 py-4 "
    >
      <ExternalLink className="size-5 text-content-primary-bold shrink-0" />
      <span className="text-sm text-content-primary-bold tracking-[0.07px] leading-6">Privacy Policy</span>
      <ArrowUpRight className="size-4 text-content-primary-subtle shrink-0 ml-auto" />
    </a>
  );

  if (isDesktop) {
    return (
      <DesktopPage>
        <DesktopPageHeader
          title="Privacy Policy"
          breadcrumb={
            <span className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => navigate({ to: '/operations/settings' })}
                className="flex size-7 items-center justify-center rounded-full hover:bg-surface-L1"
                aria-label="Back to settings"
              >
                <ArrowLeft className="size-4" />
              </button>
              <span>
                <Link to="/operations" className="hover:underline">
                  Operations
                </Link>
                <span className="text-content-primary-subtle"> / </span>
                <Link to="/operations/settings" className="hover:underline">
                  Settings
                </Link>
                <span className="text-content-primary-subtle"> / Privacy Policy</span>
              </span>
            </span>
          }
        />
        {body}
      </DesktopPage>
    );
  }

  return (
    <AppLayout
      topBar={<TopBarBackIconButton title="Privacy Policy" />}
      className="pt-6 "
    >
      {body}
    </AppLayout>
  );
}
